import * as tslib_1 from "tslib";
import * as React from 'react';
import { FormFeedback } from 'reactstrap';
/**
 * Show validation errors inside a FormFeedback.
 * @param props
 */
export var ValidatedFormFeedback = function (props) {
    // Use the ...rest technique to remove our own props from those we need to pass on to FormFeedback.
    var validationErrors = props.validationErrors, rest = tslib_1.__rest(props, ["validationErrors"]);
    // Find the errors based on the types we support.
    var errors = [];
    if (!validationErrors) {
        // Errors can stay as an empty array.
    }
    else if (typeof validationErrors === 'string') {
        errors = [validationErrors];
    }
    else if (Array.isArray(validationErrors)) {
        errors = validationErrors;
    }
    else {
        // We have ValidationErrors from Validator.errors()
        errors = validationErrors[(props.name ? props.name : '')] || [];
    }
    var hasErrors = (errors && errors.length ? true : false);
    if (!hasErrors || !errors) {
        return (React.createElement(React.Fragment, null));
    }
    return (React.createElement(FormFeedback, null, errors.map(function (item) { return (React.createElement("div", { key: item }, item)); })));
};
//# sourceMappingURL=ValidatedFormFeedback.js.map